module.exports = __webpack_public_path__ + "img/0x3782720ad22ecfdd26cc99135dbc6739a47a38c9.c65d4db9.png";